function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2016, 2026. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
import { ArrowRight, ChevronDown, ErrorFilled, Information, ChevronRight, Application, LogoGithub, User } from '@carbon/react/icons';
import AjaxValidator from '../validator2.jsx';
import autoBind from 'react-autobind';
import { Card, CardBody } from '@console/cloud-pal-community/components/Basic';
import { Accordion, AccordionItem, Checkbox, ComboBox, InlineLoading, RadioButtonGroup, RadioButton, RadioTile, Tag, Tile, TileGroup, Toggle, Toggletip, ToggletipButton, ToggletipContent, Modal } from '@carbon/react';
import commonMsgs from '../../../nls/common.properties';
import config from '../../../lib/shared/config';
import constants from '../../../lib/shared/constants';
import ConfigHelper from './formUtils.js';
import Markdown from '../../common/markdown.jsx';
import messages from '../../../nls/setup/deploy/deploy.properties';
import Notification from '../../common/notification.jsx';
import React from 'react';
import { MultiLineSecretInput, PropertyTable, SecretInput } from '@ace/otc-components-react';
import PropTypes from 'prop-types';
import urls from '../../../lib/shared/urls';
import Validator from '../validator.jsx';
import xhr from '../../../lib/client/xhr';
import vaultUtil from '../../../lib/client/vault-util';
import crn from '../../../lib/shared/crn';
import '@ace/otc-components-react/src/scss/index.scss';
import "@ace/otc-components-react/src/scss/with-property-table.scss";
import '../../../scss/setup/deploy/_integrations.scss';

// TODO fix cyclic dependencies between components ParamDiv, InputElement, SelectFieldset
// and then put into separate files.
var ParamDiv = /*#__PURE__*/function (_React$Component) {
  function ParamDiv(props) {
    var _this;
    _classCallCheck(this, ParamDiv);
    _this = _callSuper(this, ParamDiv, [props]);
    _this.state = {
      isSelected: false
    };
    _this.configHelper = new ConfigHelper(_this);
    autoBind(_this);
    return _this;
  }
  _inherits(ParamDiv, _React$Component);
  return _createClass(ParamDiv, [{
    key: "handleInfoSelect",
    value: function handleInfoSelect() {
      this.setState({
        isSelected: !this.state.isSelected
      });
    }
  }, {
    key: "isVisible",
    value: function isVisible() {
      if (typeof this.props.paramDef.visible !== 'undefined') {
        return this.props.paramDef.visible;
      }
      return true;
    }
  }, {
    key: "renderFSCloudTag",
    value: function renderFSCloudTag() {
      var _paramDef$display;
      if (!this.props.enableFSCloudDialog) {
        return;
      }
      var _this$props = this.props,
        capabilities = _this$props.capabilities,
        paramDef = _this$props.paramDef,
        wizardStep = _this$props.wizardStep;
      var paramType = paramDef === null || paramDef === void 0 ? void 0 : paramDef.type;
      var component = (_paramDef$display = paramDef.display) === null || _paramDef$display === void 0 ? void 0 : _paramDef$display.component;

      // Check if boolean toggle enables an FS Cloud Validated service
      var fsCloudTag;
      if (wizardStep && paramType === "boolean" && component === "toggle") {
        var conditions = wizardStep._getConditions();
        var foundService;
        if (conditions !== null && conditions !== void 0 && conditions.length) {
          var _iterator = _createForOfIteratorHelper(conditions),
            _step;
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              var condition = _step.value;
              var svcInCondition = wizardStep.findServiceInCondition(condition, paramDef.key);
              if (svcInCondition) {
                foundService = svcInCondition;
                break;
              }
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          ;
          if (foundService) {
            var _capabilities$catalog;
            var serviceTags = capabilities === null || capabilities === void 0 || (_capabilities$catalog = capabilities.catalog[foundService]) === null || _capabilities$catalog === void 0 ? void 0 : _capabilities$catalog.tags;
            if (serviceTags && serviceTags.includes(constants.fsCloudTag)) {
              var fscloudTagId = "fscloud_tag_".concat(foundService) + "_".concat(wizardStep.getName());
              fsCloudTag = /*#__PURE__*/React.createElement(Tag, {
                id: fscloudTagId,
                type: "cyan"
              }, commonMsgs.get("tag.fscloud"));
            }
          }
        }
      }
      return fsCloudTag;
    }
  }, {
    key: "render",
    value: function render() {
      var _paramDef$display2, _paramDef$display3;
      var paramDef = this.props.paramDef;
      //check for any dark launch flags
      var darklaunch = paramDef.darklaunch || "";
      if (darklaunch) {
        if (window.localStorage && window.localStorage.getItem(darklaunch) === null) {
          return null;
        }
      }
      var showLabel = true;
      if (paramDef.type === "selectfieldset") {
        showLabel = this.configHelper.isValidFieldSet(paramDef);
      } else if (["link", "subform", "table", "status", "accordion"].includes(paramDef.type)) {
        showLabel = false;
      }
      if (paramDef.display && paramDef.display.showLabel === false) {
        showLabel = false;
      }
      var label = paramDef.title || paramDef.description || this.props.name;

      // TODO get brokers to use fields consistently. `title`: display name of property. `description`: tooltip
      // var hasTooltip = paramDef.description && (label !== paramDef.description);
      var labelClasses = ["cds--label"];
      var tooltipValue = this.configHelper.getTooltipValue();
      var checkboxContent = /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(InputElement, _extends({}, this.props, {
        label: label || '',
        controller: this.props.controller,
        capability: this.props.capability,
        updateFormValidity: this.props.updateFormValidity,
        onFieldChange: this.props.onFieldChange,
        paramDef: paramDef,
        name: this.props.name,
        value: this.props.value,
        required: paramDef.required
      })), this.configHelper.isInvalid() ? /*#__PURE__*/React.createElement("span", {
        className: "checkbox-error"
      }, /*#__PURE__*/React.createElement(ErrorFilled, {
        className: "checkbox-error-icon"
      })) : null, tooltipValue ? /*#__PURE__*/React.createElement("span", {
        className: "checkbox-text"
      }, tooltipValue) : null, this.renderFSCloudTag());
      var tooltipContent;
      if (paramDef.description) {
        tooltipContent = /*#__PURE__*/React.createElement("div", {
          className: "info-div"
        }, /*#__PURE__*/React.createElement(Toggletip, {
          className: "tooltip",
          align: "right"
        }, /*#__PURE__*/React.createElement(ToggletipButton, null, /*#__PURE__*/React.createElement(Information, null)), /*#__PURE__*/React.createElement(ToggletipContent, null, /*#__PURE__*/React.createElement(Markdown, {
          content: paramDef.description || ""
        }))));
      }
      var paramType = paramDef === null || paramDef === void 0 ? void 0 : paramDef.type;
      var component = (_paramDef$display2 = paramDef.display) === null || _paramDef$display2 === void 0 ? void 0 : _paramDef$display2.component;
      var displayStyle = (_paramDef$display3 = paramDef.display) === null || _paramDef$display3 === void 0 ? void 0 : _paramDef$display3.style;
      return this.isVisible() ? /*#__PURE__*/React.createElement("div", {
        className: "cds--form-item",
        "data-type": paramType
      }, /*#__PURE__*/React.createElement("div", {
        className: "detailsFormLabelDiv"
      }, paramType === "boolean" && component !== "toggle" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("span", {
        className: "checkBoxSpan"
      }, checkboxContent), tooltipContent), paramType === "boolean" && component === "toggle" && displayStyle === "card" && /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(CardBody, null, /*#__PURE__*/React.createElement("div", {
        className: "card-toggle-container"
      }, checkboxContent), tooltipContent)), paramType === "boolean" && component === "toggle" && displayStyle === "standalone" && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: "standalone-toggle-container"
      }, checkboxContent), tooltipContent), paramType !== "boolean" && paramType !== "label" && showLabel && label && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("label", {
        className: labelClasses.join(" ")
      }, label), tooltipContent)), /*#__PURE__*/React.createElement("div", {
        className: "detailsFormInputDiv"
      }, paramType === "boolean" ? null : /*#__PURE__*/React.createElement(InputElement, _extends({}, this.props, {
        updateFormValidity: this.props.updateFormValidity,
        controller: this.props.controller,
        ariaLabelledby: this.props.ariaLabelledby + " " + this.props.name,
        capability: this.props.capability,
        onFieldChange: this.props.onFieldChange,
        paramDef: paramDef,
        name: this.props.name,
        value: this.props.value,
        required: paramDef.required
      })))) : null;
    }
  }]);
}(React.Component);
export { ParamDiv as default };
ParamDiv.propTypes = _objectSpread(_objectSpread({}, ParamDiv.propTypes), {}, {
  enableFSCloudDialog: PropTypes.bool.isRequired,
  enableSecretSmProvider: PropTypes.bool.isRequired,
  envId: PropTypes.string.isRequired,
  locale: PropTypes.string.isRequired,
  readOnly: PropTypes.bool.isRequired,
  wizardMode: PropTypes.bool.isRequired
});

// Used by both SelectFieldSet and InputElement
var renderTile = function renderTile(_ref) {
  var isSolo = _ref.isSolo,
    name = _ref.name,
    stepName = _ref.stepName,
    value = _ref.value;
  if (!isSolo) {
    // For multi-tile group, use selectable RadioTiles
    return /*#__PURE__*/React.createElement(RadioTile, {
      "data-analytics-track": "".concat(stepName, "-").concat(value, "-tile"),
      key: value,
      light: true,
      value: value
    }, /*#__PURE__*/React.createElement(Markdown, {
      className: "wizard-radio-tile",
      content: name
    }));
  } else {
    // For single tile use case, use Card
    return /*#__PURE__*/React.createElement(Tile, {
      className: "solo-tile",
      "data-analytics-track": "".concat(stepName, "-").concat(value, "-tile"),
      key: value,
      light: true
    }, /*#__PURE__*/React.createElement(Markdown, {
      className: "wizard-solo-tile",
      content: name
    }));
  }
};
var getTileData = function getTileData(tile, paramDef) {
  // Pull name and value for a tile from the paramDef
  var name = tile;
  var value = tile;
  // Check for a title map
  if (paramDef.titleMap) {
    // Title exists for key
    if (paramDef.titleMap[name]) {
      name = paramDef.titleMap[name];
    } else {
      // Title does not exist for entry. Do not create a select option.
      return null;
    }
  }
  if (_typeof(tile) === "object") {
    name = tile.name;
    value = tile.value;
  }
  return {
    name: name,
    value: value
  };
};
var SelectFieldset = /*#__PURE__*/function (_React$Component2) {
  function SelectFieldset(props) {
    var _this2;
    _classCallCheck(this, SelectFieldset);
    _this2 = _callSuper(this, SelectFieldset, [props]);
    _this2.state = {
      isSelected: false
    };
    _this2.configHelper = new ConfigHelper(_this2);
    autoBind(_this2);
    return _this2;
  }
  _inherits(SelectFieldset, _React$Component2);
  return _createClass(SelectFieldset, [{
    key: "handleChange",
    value: function handleChange(evt) {
      this.props.onFieldChange(evt);
    }
  }, {
    key: "handleInfoSelect",
    value: function handleInfoSelect() {
      this.setState({
        isSelected: !this.state.isSelected
      });
    }
  }, {
    key: "renderOptions",
    value: function renderOptions() {
      var props = this.props;
      var component = props.paramDef.display && props.paramDef.display.component;
      var isSolo = props.paramDef.enum && props.paramDef.enum.length === 1;
      return props.paramDef.enum.map(function (option) {
        var tileData = getTileData(option, props.paramDef);
        if (!tileData) {
          // Title does not exist for entry. Do not create a select option.
          return;
        }
        var name = tileData.name,
          value = tileData.value;
        if (component === "tilegroup") {
          var wizardAnalyticsPrefix = props.wizardStep ? props.wizardStep.getName() : "";
          return renderTile({
            isSolo: isSolo,
            name: name,
            wizardAnalyticsPrefix: wizardAnalyticsPrefix,
            value: value
          });
        } else if (component === "radiogroup") {
          return /*#__PURE__*/React.createElement(RadioButton, {
            labelText: name,
            value: value,
            key: value
          });
        } else {
          return /*#__PURE__*/React.createElement("option", {
            className: "cds--select-option",
            key: value,
            value: value
          }, name);
        }
      });
    }
  }, {
    key: "renderInvalidOption",
    value: function renderInvalidOption(txt) {
      // Note, there is css for: .form-div { .textInfo {
      return /*#__PURE__*/React.createElement("div", {
        className: "textInfo"
      }, /*#__PURE__*/React.createElement(Notification, {
        kind: "warning",
        lowContrast: true,
        title: commonMsgs.get("warning"),
        format: "markdown",
        subtitle: txt || ""
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props$paramDef$;
      var i = 0;
      var props = this.props;
      var result = null;
      var validFieldSet = this.configHelper.isValidFieldSet(props.paramDef);
      var items = [];
      var lightBackground = this.props.lightBackground;
      var label = props.paramDef.title || props.paramDef.description || props.name;
      if (!validFieldSet) {
        result = {};
        for (var p in this.props.serviceParams) {
          if (this.configHelper.isValidParam(p)) {
            result[p] = p;
          }
        }
        var parameters = this.props.capability.metadata.parameters || {},
          properties = parameters.properties;
        for (var key in result) {
          if (properties && properties[key]) {
            var tmp = properties[key];
            tmp.key = key;
            items.push(tmp);
          }
        }
      }

      // Note, selectfieldset paramDef['override-value'] prevents the user from choosing other values; mechanism added for git-broker
      var selectValue = props.paramDef['override-value'] || props.value;
      props.paramDef.enum.some(function (option, j) {
        var value = option;
        if (_typeof(option) === "object") {
          value = option.value;
        }
        if (selectValue === value) {
          i = j;
          return true;
        }
      });
      if (this.props.paramDef.enum[i] !== props.value) {
        // empty-string can be accidentally set by initial edit box display before converts to selectfieldset;
        // in that case, don't show warning for invalid option, instead allow change from empty-string to enum[0] value
        var isExplicitInvalidOption = props.value !== "";
        var invalidOptionMsg = this.props.paramDef.display && this.props.paramDef.display.invalidOptionMsg;
        if (isExplicitInvalidOption && invalidOptionMsg) {
          return this.renderInvalidOption(invalidOptionMsg);
        } else {
          this.props.onFieldChange({
            target: {
              name: this.props.name,
              value: this.props.paramDef.enum[i]
            }
          });
        }
      }

      // adapt data to an event
      var handleRadioChange = function handleRadioChange(data) {
        if (data !== props.value) {
          props.onFieldChange({
            target: {
              name: props.name,
              value: data
            }
          });
        }
      };
      var component = props.paramDef.display && props.paramDef.display.component;
      var orientation = props.paramDef.display && props.paramDef.display.orientation;
      return /*#__PURE__*/React.createElement("fieldset", null, /*#__PURE__*/React.createElement("legend", null, label), (validFieldSet || props.name in result) && /*#__PURE__*/React.createElement("div", {
        className: "cds--form-item",
        "data-type": this.props.paramDef.type
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--select" + (lightBackground ? " cds--select--light" : "")
      }, /*#__PURE__*/React.createElement("div", {
        className: "cds--select-input__wrapper"
      }, component === "tilegroup" && props.paramDef.enum && props.paramDef.enum.length > 1 && /*#__PURE__*/React.createElement(TileGroup, {
        "aria-label": label,
        className: orientation === "vertical" ? "tile-group tile-group-vertical" : "tile-group tile-group-horizontal",
        disabled: props.disabled,
        name: props.name,
        onChange: handleRadioChange,
        valueSelected: props.value,
        defaultSelected: ((_this$props$paramDef$ = this.props.paramDef.enum) === null || _this$props$paramDef$ === void 0 ? void 0 : _this$props$paramDef$.length) && this.props.paramDef.enum[0],
        legend: messages.get('legend.tile_group', [label])
      }, this.renderOptions()), component === "tilegroup" && props.paramDef.enum && props.paramDef.enum.length === 1 && this.renderOptions(), component === "radiogroup" && /*#__PURE__*/React.createElement(RadioButtonGroup, {
        name: props.name,
        "aria-label": label,
        valueSelected: props.value,
        onChange: handleRadioChange,
        disabled: props.disabled,
        orientation: orientation ? orientation : 'vertical'
      }, this.renderOptions()), !["radiogroup", "tilegroup", "hidden"].includes(component) && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", {
        name: props.name,
        "aria-label": label,
        value: props.value,
        selected: props.value,
        onChange: props.onFieldChange,
        className: "cds--select-input",
        disabled: props.disabled
      }, "(", this.renderOptions(), ")"), /*#__PURE__*/React.createElement(ChevronDown, {
        className: "cds--select__arrow"
      }))), function () {
        var item = props.paramDef.items[i];
        props.validatorTracker.validators().forEach(function (validator) {
          validator.setValidityOverride(item.overrideValidity ? true : false);
        });
        if (validFieldSet) {
          if (item && item.description) {
            return /*#__PURE__*/React.createElement(Markdown, {
              className: "info-desc",
              content: item.description
            });
          } else {
            return /*#__PURE__*/React.createElement("div", {
              className: "cds--form-requirement"
            });
          }
        }
      }())), function () {
        var item = JSON.parse(JSON.stringify(props.paramDef.items[i]));
        return /*#__PURE__*/React.createElement(InputElement, _extends({}, props, {
          controller: props.controller,
          capability: props.capability,
          onFieldChange: props.onFieldChange,
          paramDef: item,
          name: item.name || "",
          value: item.value || "",
          required: props.paramDef.required || false,
          filteredItems: result
        }));
      }());
    }
  }]);
}(React.Component);
var Subform = /*#__PURE__*/function (_React$Component3) {
  function Subform(props) {
    var _this3;
    _classCallCheck(this, Subform);
    _this3 = _callSuper(this, Subform, [props]);
    autoBind(_this3);
    return _this3;
  }
  _inherits(Subform, _React$Component3);
  return _createClass(Subform, [{
    key: "subformRequest",
    value: function subformRequest(evt) {
      evt.preventDefault();
      var props = this.props;
      var HTTP_METHODS = ["GET", "HEAD", "POST", "PUT", "DELETE", "CONNECT", "OPTIONS", "TRACE", "PATCH"];
      var httpMethod = props.paramDef.submit.httpMethod;
      var locale = this.props.locale;
      var body = {
        parameters: props.capability.parameters
      };
      httpMethod = HTTP_METHODS.indexOf(httpMethod) === -1 ? "POST" : httpMethod;
      if (props.setStateRunning) {
        props.setStateRunning(true);
      }
      xhr(config.CONTEXT_PATH + props.paramDef.submit.url, {
        method: httpMethod,
        dataType: 'json',
        body: body
      }, function (error, data, xhr) {
        if (error) {
          var err = new Error(error.title || commonMsgs.get('notification.error.title', locale));
          err.details = error.description || commonMsgs.get('notification.error.msg', locale);
          return this.subformResponse(err);
        }
        var changes = data.parameters || {};
        return this.subformResponse(null, changes);
      }.bind(this));
    }
  }, {
    key: "subformResponse",
    value: function subformResponse(error, changes) {
      var props = this.props;
      if (changes) {
        var changeSummary = Object.create(null);
        Object.keys(changes).forEach(function (prop) {
          var oldValue = props.capability.parameters[prop];
          var newValue = changes[prop];
          if (typeof newValue !== "undefined" && oldValue !== newValue) {
            changeSummary[prop] = {
              source: "validator"
            };
          }
          props.capability.parameters[prop] = newValue;
        }.bind(this));
        props.onScheduleWork("populate", [{
          capability: props.capability,
          changeSummary: changeSummary
        }]);
      }
      props.handleError(error);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;
      var props = this.props;
      var parameters = props.capability.parameters;
      return /*#__PURE__*/React.createElement("div", null, props.paramDef.items.map(function (item, i) {
        if (_this4.props.isFieldHidden && _this4.props.isFieldHidden(item.key || "")) {
          return null;
        }
        return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, props, {
          key: item.key ? "".concat(item.key, "_").concat(i) : "subformItem_".concat(i),
          controller: props.controller,
          capability: props.capability,
          onFieldChange: props.onFieldChange,
          paramDef: item,
          name: item.key,
          value: parameters[item.key] || item.value,
          required: item.required || false,
          filteredItems: null
        }));
      }), /*#__PURE__*/React.createElement("div", {
        className: "cds--form-item"
      }, /*#__PURE__*/React.createElement("button", {
        className: "cds--btn cds--btn--primary",
        onClick: this.subformRequest,
        disabled: props.paramDef.submit.disabled
      }, props.paramDef.submit.label)));
    }
  }]);
}(React.Component);
var ObjectDiv = /*#__PURE__*/function (_React$Component4) {
  function ObjectDiv(props) {
    var _this5;
    _classCallCheck(this, ObjectDiv);
    _this5 = _callSuper(this, ObjectDiv, [props]);
    autoBind(_this5);
    return _this5;
  }
  _inherits(ObjectDiv, _React$Component4);
  return _createClass(ObjectDiv, [{
    key: "render",
    value: function render() {
      var props = this.props;
      var result = null;
      return /*#__PURE__*/React.createElement("div", {
        className: "indenter"
      }, props.paramDef.items.map(function (item, i) {
        var objName = item.title || "";
        var objValue = item.value || "";
        if (objValue === "" && props.capability.parameters[props.name] && objName in props.capability.parameters[props.name]) {
          objValue = props.capability.parameters[props.name][objName];
          objName = props.name + "." + objName;
        }
        if (this.props.isFieldHidden && this.props.isFieldHidden(objName)) {
          return null;
        }
        return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, props, {
          key: item.key ? "".concat(item.key, "_").concat(i) : "objectdivItem_".concat(i),
          controller: props.controller,
          capability: props.capability,
          onFieldChange: props.onFieldChange,
          paramDef: item,
          name: objName,
          value: objValue || "",
          required: props.paramDef.required || false,
          filteredItems: result
        }));
      }));
    }
  }]);
}(React.Component);
var InputElement = /*#__PURE__*/function (_React$Component5) {
  function InputElement(props) {
    var _this6;
    _classCallCheck(this, InputElement);
    _this6 = _callSuper(this, InputElement, [props]);
    var props = _this6.props;
    var templateServices = undefined;
    if (props.capabilities) {
      var topLevelData = props.capabilities.getTopLevelData();
      if (topLevelData) {
        templateServices = topLevelData.services;
      }
    }
    _this6.state = {
      vaultIntegrations: vaultUtil.getVaultIntegrations(templateServices),
      notifyDialog: {
        open: false
      }
    };
    _this6.customValidity = /*#__PURE__*/React.createRef();
    _this6.configHelper = new ConfigHelper(_this6);
    autoBind(_this6);
    return _this6;
  }
  _inherits(InputElement, _React$Component5);
  return _createClass(InputElement, [{
    key: "onFieldChange",
    value: function onFieldChange(evt) {
      this.props.onFieldChange(evt);
      this.props.updateFormValidity();
    }
  }, {
    key: "beforeOnFieldChange",
    value: function beforeOnFieldChange(value, next) {
      if (!vaultUtil.isVaultProperty(this.props.name, this.props.capability, this.props.context)) {
        return next(value);
      }
      if (this.props.onDetectSecretReference) {
        return this.props.onDetectSecretReference(value, next);
      }
      // Note, in add-a-tool / configure tool
      // not adding new vault integrations on dismiss secret dialog
      // TODO allow ref vaultIntegrations in add-a-tool
      // and in configure tool - currently doesn't list existing
      // tool integrations in this toolchain in the picker dialog
      return next(value);
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateCustomValidity();
    }
  }, {
    key: "getFormDiv",
    value: function getFormDiv(el, cls) {
      while ((el = el.parentElement) && !el.classList.contains(cls));
      return el;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this7 = this;
      this.updateCustomValidity();
      if (this.props.shouldFocus) {
        if (this.configHelper.isInvalid()) {
          var textInputElement = this.customValidity.current;
          if (textInputElement) {
            var formDiv = this.getFormDiv(textInputElement, "form-content-div");
            if (formDiv) {
              var allInvalidInputFields = formDiv.querySelectorAll("input[data-isinvalid='true']");
              if (allInvalidInputFields[0] === textInputElement) {
                setTimeout(function () {
                  textInputElement.focus();
                  _this7.props.updateFocus(false);
                }, 0);
              }
            }
          }
        }
      }
      var dropdownEnum;
      if (this.getComponentType() === 'dropdown' && this.props.paramDef && (dropdownEnum = this.props.paramDef.enum) && dropdownEnum.length > 0 && (this.props.paramDef.readonly === undefined || this.props.paramDef.readonly)) {
        var items = dropdownEnum.map(function (option) {
          var name = option,
            value = option;
          if (_typeof(option) === "object") {
            name = option.name || Object.values(option)[0];
            value = option.value || Object.keys(option)[0];
          }
          return {
            name: name,
            value: value
          };
        });
        var useFirst = this.props.value === '' && items[0].value !== '' || !items.find(function (option) {
          return option.value === _this7.props.value;
        });
        if (useFirst) {
          // setDirty=false ensures that auto-picking the first option does not set a dirty state
          this.props.onFieldChange({
            target: {
              setDirty: false,
              name: this.props.name,
              value: items[0].value
            }
          });
        }
      }
    }
  }, {
    key: "updateCustomValidity",
    value: function updateCustomValidity() {
      if (!this.customValidity.current) {
        return;
      }
      var validationMsg = this.configHelper.getTooltipValue();
      if (!validationMsg && !this.lastValidationMsg) {
        return;
      }
      var element = this.customValidity.current;
      if (validationMsg) {
        this.lastValidationMsg = validationMsg;

        // prevents the default HTML effor message from appearing
        element.setCustomValidity(" ");
      } else if (this.lastValidationMsg) {
        element.setCustomValidity("");
        this.lastValidationMsg = null;
      }
    }
  }, {
    key: "getComponentType",
    value: function getComponentType() {
      // If more component types are added you may have to adjust
      // _mirrorAdvancedEnum && _getAdvancedEnum in wizard-step.js
      var paramDef = this.props.paramDef;
      var type = paramDef.type;
      if (paramDef.enum && !["selectfieldset", "radiogroup", "tilegroup", "radiocards"].includes(type)) {
        return "dropdown";
      }
      switch (type) {
        case "boolean":
          return "checkbox";
        case "string":
        case "password":
          return "textbox";
        case "table":
        case "textarea":
        case "label":
        case "info":
        case "notification":
        case "icon":
        case "group":
        case "validator":
        case "link":
        case "selectfieldset":
        case "subform":
        case "section":
        case "object":
        case "status":
        case "accordion":
        case "radiogroup":
        case "tilegroup":
        case "radiocards":
        case "propertylist":
        case "authorizationbtn":
          return type;
      }
      return "textbox";
    }
  }, {
    key: "useAjaxValidator",
    value: function useAjaxValidator(props) {
      if (props.paramDef && props.paramDef.source) {
        return props.paramDef.source === "broker";
      } else {
        //temp. enable  use of avp flow through local storage
        var flag = false;
        if (window.localStorage) {
          var flag = window.localStorage.getItem("avp") || false;
          flag = flag === "true";
        }
        return flag;
      }
    }
  }, {
    key: "handleFocusOut",
    value: function handleFocusOut(event) {
      var value = event.target.value;
      //check for leading and trailing spaces in toolchain name
      if (value !== '' && /^\s|\s$/.test(value) && event.target.type === "text") {
        var newVal = value.trim();
        var element = this.customValidity.current;
        if (element) element.value = newVal;
        this.props.onFieldChange(event);
      }
    }
  }, {
    key: "onModalEvent",
    value: function onModalEvent(open) {
      var deployPageContentContainer = document.getElementsByClassName('deploy-page-content')[0];
      if (deployPageContentContainer) {
        var method = open ? 'add' : 'remove';
        deployPageContentContainer.classList[method]('interior-modal-open');
      }
    }
  }, {
    key: "onSecretInputModalEvent",
    value: function onSecretInputModalEvent(open) {
      this.onModalEvent(open);
      if (open) {
        var templateServices = undefined;
        if (this.props.capabilities) {
          var topLevelData = this.props.capabilities.getTopLevelData();
          if (topLevelData) {
            templateServices = topLevelData.services;
          }
        }
        this.setState({
          "vaultIntegrations": vaultUtil.getVaultIntegrations(templateServices)
        });
      }
    }
  }, {
    key: "isSecretPickerEnabled",
    value: function isSecretPickerEnabled() {
      return this.props.context && this.props.context.enableSecretPicker;
    }
  }, {
    key: "isServiceIdApiKeyProp",
    value: function isServiceIdApiKeyProp() {
      if (this.props.paramDef && this.props.paramDef.validator) {
        return ['service-id-api-key'].includes(this.props.paramDef.validator['v-type']);
      }
      return false;
    }
  }, {
    key: "isOldApiKeyProp",
    value: function isOldApiKeyProp() {
      if (this.props.paramDef && this.props.paramDef.type === "ibm-cloud-api-key") {
        return true;
      }
      return ['api-key', 'iam-api-key', 'ibmcloud-api-key'].includes(this.props.name) && !this.isNewApiKeyProp();
    }
  }, {
    key: "isNewApiKeyProp",
    value: function isNewApiKeyProp() {
      if (this.props.paramDef && this.props.paramDef.validator) {
        return ['api-key'].includes(this.props.paramDef.validator['v-type']);
      }
      return false;
    }
  }, {
    key: "isApiKeyProp",
    value: function isApiKeyProp() {
      return this.isNewApiKeyProp() || this.isOldApiKeyProp();
    }
  }, {
    key: "isGPGKeyProp",
    value: function isGPGKeyProp() {
      if (this.props.paramDef && this.props.paramDef.validator) {
        return ['gpg-private-key'].includes(this.props.paramDef.validator['v-type']);
      }
      return false;
    }
  }, {
    key: "isPasswordProp",
    value: function isPasswordProp() {
      return this.props.paramDef && this.props.paramDef.type === "password" || this.isApiKeyProp() || this.isServiceIdApiKeyProp();
    }
  }, {
    key: "getSecretInputKeyCreationType",
    value: function getSecretInputKeyCreationType() {
      if (this.isServiceIdApiKeyProp()) {
        return 'service-id';
      } else if (this.isGPGKeyProp()) {
        return 'gpg-key';
      } else {
        return 'api-key';
      }
    }
  }, {
    key: "handleCreateAuthorizationClick",
    value: function handleCreateAuthorizationClick(evt) {
      var _this$props$toolchain;
      evt.preventDefault();
      evt.stopPropagation();
      switch (this.props.capability.capabilityId) {
        case 'secretsmanager':
        case 'keyprotect':
        case 'appconfig':
        case 'eventnotifications':
          // Start the spinner
          this.props.setStateRunning && this.props.setStateRunning(true);
          xhr(config.CONTEXT_PATH + "/setup/api/v2/s2s_authorization?toolchainId=".concat((_this$props$toolchain = this.props.toolchain) === null || _this$props$toolchain === void 0 ? void 0 : _this$props$toolchain.toolchain_guid, "&serviceId=").concat(this.props.capability.capabilityId), {
            method: 'POST',
            body: {
              parameters: this.props.capability.parameters
            },
            dataType: 'json'
          }, function (error, data, xhr) {
            // Stop the spinner
            this.props.setStateRunning && this.props.setStateRunning(false);
            if (error) {
              // Show a failure dialog
              this.setState({
                notifyDialog: {
                  open: true,
                  heading: messages.get("error.createAuthorizationErrorHeading"),
                  description: (data === null || data === void 0 ? void 0 : data.errorMessage) || messages.get("error.createAuthorizationGenericError")
                }
              });
            } else {
              // Show a success dialog
              this.setState({
                notifyDialog: {
                  open: true,
                  heading: messages.get("info.createAuthorizationSuccessHeading"),
                  dangerousHtmlDescription: messages.get("info.createAuthorizationSuccess")
                }
              });

              // Trigger a new status check
              // Need to set this to a falsey value other than undefined
              this.props.capability.parameters['integration-status'] = "";
              var changeSummary = {
                "integration-status": {
                  source: "validator"
                }
              };
              this.props.onScheduleWork("populate", [{
                capability: this.props.capability,
                changeSummary: changeSummary
              }]);
            }
          }.bind(this));
          break;
        default:
          break;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this8 = this,
        _tilesDef$enum,
        _tilesDef$display,
        _tilesDef$enum2,
        _tilesDef$enum3;
      var props = this.props;
      var component = this.getComponentType(),
        element;
      var type = props.paramDef.type,
        value = props.value;
      var maybeRequired = props.required ? {
        "data-required": ""
      } : {};
      var isInvalid = this.configHelper.isInvalid();
      var tooltipValue = this.configHelper.getTooltipValue();
      var lightBackground = this.props.lightBackground;
      var toolIntegName = this.props.capability.label;
      var uniqueId = this.props.id ? "".concat(toolIntegName, "-").concat(this.props.id) : undefined;
      var parameters = props.capability.parameters;
      var label = props.paramDef.title || props.paramDef.description || props.name;
      var placeholderText = props.paramDef.placeholder;
      var isLoading = props.paramDef.spinner === "start";
      var populateSpinner = "text-spinner ".concat(!isLoading ? 'info-desc-hidden' : '');
      var toolchainName = this.props.capabilities && this.props.capabilities.getToolchain() && this.props.capabilities.getToolchain().name;
      toolchainName = toolchainName || this.props.toolchain && this.props.toolchain.name;
      var toolchainId = this.props.toolchain && this.props.toolchain.toolchain_guid;
      switch (component) {
        case "link":
          var clickFunc = function clickFunc(e) {
            window.open(props.paramDef.url);
            e.preventDefault();
          };
          return /*#__PURE__*/React.createElement("button", {
            className: "cds--btn",
            onClick: clickFunc,
            disabled: props.disabled
          }, props.paramDef.label);
        case "label":
          return /*#__PURE__*/React.createElement(Markdown, {
            id: uniqueId,
            className: "labelInfo",
            content: props.paramDef.title || ""
          });
        case "icon":
          switch (props.paramDef.iconType) {
            case "right_arrow":
              return /*#__PURE__*/React.createElement(ArrowRight, {
                size: 20,
                className: "colArrow__icon"
              });
          }
          return '';
        case "validator":
          if (!props.disabled) {
            var toolchainBssAccountId = this.props.toolchain && this.props.toolchain.crn && crn.decomposeCRN(this.props.toolchain.crn).accountId;
            var validatorUrl = props.paramDef.url;
            if (validatorUrl && this.props.envId) {
              validatorUrl = urls.addUrlParam(validatorUrl, 'env_id', this.props.envId);
            }
            var ValidatorComponent = this.useAjaxValidator(props) ? AjaxValidator : Validator;
            return /*#__PURE__*/React.createElement(ValidatorComponent, {
              validatorTracker: props.validatorTracker,
              controller: props.controller,
              capability: props.capability,
              url: validatorUrl,
              cfTarget: props.cfTarget,
              userInfo: props.userInfo,
              account: props.account,
              getLastModification: props.getLastModification,
              onScheduleWork: props.onScheduleWork,
              isFormValid: props.isFormValid,
              overrideFormValidity: props.overrideFormValidity,
              capabilities: props.capabilities,
              toolchainId: toolchainId,
              toolchainBssAccountId: toolchainBssAccountId,
              context: this.props.context
            });
          }
          // validation is turned off for disabled (read-only) components
          return /*#__PURE__*/React.createElement("div", null);
        case "selectfieldset":
          return /*#__PURE__*/React.createElement(SelectFieldset, props);
        case "subform":
          return /*#__PURE__*/React.createElement(Subform, props);
        case "object":
          return /*#__PURE__*/React.createElement(ObjectDiv, props);
        case "textarea":
          var extraTaProps = Object.assign({}, maybeRequired);
          if (props.paramDef.readonly) {
            extraTaProps.readOnly = true;
          }
          if (tooltipValue) {
            extraTaProps["data-show-required-tooltip"] = true;
          }
          if (isInvalid) {
            extraTaProps["data-invalid"] = isInvalid;
          }
          return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("textarea", _extends({
            name: props.name,
            id: props.name,
            onChange: props.onFieldChange,
            className: "cds--text-area" + (lightBackground ? " cds--text-area--light" : ""),
            rows: "4",
            cols: "100%",
            placeholder: placeholderText || label,
            "aria-labelledby": this.props.ariaLabelledby,
            value: value,
            onBlur: this.handleFocusOut,
            disabled: props.disabled
          }, extraTaProps)), /*#__PURE__*/React.createElement("div", {
            className: "cds--form-requirement"
          }, tooltipValue));
        case "textbox":
          var idPrefix = toolIntegName ? "".concat(toolIntegName, "-").concat(this.props.name) : "".concat(this.props.name);
          var extraTextboxProps = Object.assign({}, maybeRequired);
          var textboxDisabled = props.disabled || this.props.readOnly;
          var required = false;
          if (props.paramDef.readonly) {
            extraTextboxProps.readOnly = true;
          }
          if (props.validationMessages && props.validationMessages[props.name]) {
            required = true;
          }
          if (tooltipValue) {
            extraTextboxProps["data-show-required-tooltip"] = true;
          }
          if (isInvalid) {
            extraTextboxProps["data-isinvalid"] = isInvalid;
            extraTextboxProps["data-invalid"] = isInvalid;
          }
          if (props.paramDef && props.paramDef.validator && props.paramDef.validator.disabled === true) {
            // Bm-helper validator-v1 - disable control without error
            delete extraTextboxProps["data-isinvalid"];
            delete extraTextboxProps["data-invalid"];
            delete extraTextboxProps["data-show-required-tooltip"];
            isInvalid = false;
            textboxDisabled = true;
          }
          var noIntegrationsProps = {};
          var analyticsPrefix;
          if (this.isPasswordProp() && this.props.wizardMode) {
            analyticsPrefix = this.props.wizardStep.getName();
            if (this.props.hasSecretsStep) {
              // Custom error handling when no valid secret integrations found
              var heading, okString, errorMarkdown;
              if (this.props.hasInvalidSecretsIntegration) {
                // A secrets integration has been added, but it is invalid
                heading = messages.get("wizard.secrets.invalidIntegration.heading");
                okString = messages.get("wizard.secrets.invalidIntegration.action");
                errorMarkdown = /*#__PURE__*/React.createElement(Markdown, {
                  content: messages.get("wizard.secrets.invalidIntegration.warning")
                });
              } else {
                // No secrets integration has been added
                heading = messages.get("wizard.secrets.noIntegrations.heading");
                okString = messages.get("wizard.secrets.noIntegrations.action");
                errorMarkdown = /*#__PURE__*/React.createElement(Markdown, {
                  content: messages.get("wizard.secrets.noIntegrations.warning")
                });
              }
              noIntegrationsProps = {
                error: errorMarkdown,
                heading: heading,
                okString: okString,
                okAction: function okAction(closeDialogCallback) {
                  _this8.props.openSecretsStep();
                  closeDialogCallback();
                }
              };
            }
          }
          var isMultiline = props.paramDef.display && props.paramDef.display.component === "multiline";
          var multilineVaultEnabled = vaultUtil.isVaultProperty(this.props.name, this.props.capability, this.props.context);
          return this.isPasswordProp() ? isMultiline ? /*#__PURE__*/React.createElement(MultiLineSecretInput, _extends({
            accountContext: this.props.userInfo && this.props.userInfo.account_context,
            bssAccount: this.props.userInfo && this.props.userInfo.bss_account,
            enableSmProvider: this.props.enableSecretSmProvider,
            envId: urls.param(location.href, 'env_id'),
            error: isInvalid ? tooltipValue : "",
            idPrefix: idPrefix,
            label: label,
            name: props.name,
            noIntegrationsModal: noIntegrationsProps,
            onChange: this.onFieldChange,
            onlyVtiProviders: this.props.wizardMode,
            onModalEvent: this.onSecretInputModalEvent,
            readonly: this.props.readOnly,
            spinner: props.paramDef.spinner,
            toolchainId: toolchainId,
            toolchainName: toolchainName,
            userInfo: this.props.userInfo,
            value: value,
            vaultEnabled: multilineVaultEnabled,
            vaultIntegrations: this.state.vaultIntegrations
          }, this.props.wizardMode ? {} : {
            beforeOnChange: this.beforeOnFieldChange
          })) : /*#__PURE__*/React.createElement(SecretInput, _extends({
            accountType: this.props.account && this.props.account.type,
            allowKeyCreation: this.isApiKeyProp() || this.isServiceIdApiKeyProp() || this.isGPGKeyProp(),
            analyticsPrefix: analyticsPrefix,
            accountContext: this.props.userInfo && this.props.userInfo.account_context,
            bssAccount: this.props.userInfo && this.props.userInfo.bss_account,
            enableSmProvider: this.props.enableSecretSmProvider,
            envId: urls.param(location.href, 'env_id') /* TODO can we use {this.props.envId} ? */,
            error: isInvalid ? tooltipValue : "",
            i18nStrings: this.isServiceIdApiKeyProp() ? {
              createServiceIDDescription: commonMsgs.get('create.service.id.for.private.worker', this.props.locale)
            } : {},
            idPrefix: idPrefix,
            keyCreationType: this.getSecretInputKeyCreationType(),
            label: label,
            light: lightBackground,
            minHeight: this.isApiKeyProp() || this.isServiceIdApiKeyProp() ? '62px' : '50px',
            name: props.name,
            noIntegrationsModal: noIntegrationsProps,
            onChange: this.onFieldChange,
            onlyVtiProviders: this.props.wizardMode,
            onModalEvent: this.onSecretInputModalEvent,
            readonly: this.props.readOnly,
            showWarning: this.isServiceIdApiKeyProp(),
            spinner: props.paramDef.spinner,
            toolchainId: toolchainId,
            toolchainName: toolchainName,
            userInfo: this.props.userInfo,
            value: value,
            vaultEnabled: vaultUtil.isVaultProperty(this.props.name, this.props.capability, this.props.context),
            vaultIntegrations: this.state.vaultIntegrations
            /* No dynamic toolcard generation in wizard mode */
          }, this.props.wizardMode ? {} : {
            beforeOnChange: this.beforeOnFieldChange
          })) : /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", {
            className: "input-container",
            "data-type": required
          }, /*#__PURE__*/React.createElement("input", _extends({
            name: props.name,
            autoComplete: "on",
            ref: this.customValidity,
            "aria-label": label,
            "aria-describedby": props.name + "_description",
            onChange: this.onFieldChange,
            type: "text",
            placeholder: placeholderText || label,
            className: "cds--text-input detailsFormInput" + (lightBackground ? " cds--text-input--light" : ""),
            value: value,
            onBlur: this.handleFocusOut,
            disabled: textboxDisabled
          }, extraTextboxProps)), /*#__PURE__*/React.createElement("div", {
            className: populateSpinner
          }, /*#__PURE__*/React.createElement(InlineLoading, {
            className: "spinner-icon"
          })), /*#__PURE__*/React.createElement("div", {
            className: "cds--form-requirement",
            id: props.name + "_description"
          }, isInvalid ? tooltipValue : "")));
        case "info":
          return /*#__PURE__*/React.createElement(Markdown, {
            id: uniqueId,
            className: "textInfo",
            content: props.paramDef.text || ""
          });
        case "notification":
          var kind = props.paramDef.display && props.paramDef.display.style || "info";
          var title = props.paramDef.display && props.paramDef.display.title || "";
          var subtitle = props.paramDef.display && props.paramDef.display.subtitle || "";
          return /*#__PURE__*/React.createElement("div", {
            className: "textInfo"
          }, /*#__PURE__*/React.createElement(Notification, {
            kind: kind,
            lowContrast: true,
            title: title,
            format: "markdown",
            subtitle: subtitle || ""
          }));
        case "checkbox":
          var maybeChecked = value ? {
            checked: true
          } : {};
          var extraCheckboxProps = Object.assign({}, maybeChecked, maybeRequired);
          var ctrlId = this.props.capability.label;
          var inputId = ctrlId + "_" + props.name;
          var inputName = props.name;
          if (type === 'boolean') {
            // Note, for a11y, boolean checkbox name is prefixed by form name
            // to prevent duplicate names across different forms,
            // and the prefix will be removed again
            // during data update when data-paramdef-type == 'boolean' is detected
            inputName = ctrlId + "_" + props.name;
            extraCheckboxProps = Object.assign(extraCheckboxProps, {
              'data-paramdef-type': type
            });
          }
          var _component = props.paramDef.display && props.paramDef.display.component;
          if (_component === "toggle") {
            var handleToggle = function handleToggle(value) {
              // adapt value to an event
              props.onFieldChange({
                // Note, <Toggle doesn't need data-paramdef-type,
                // as providing unprefixed name here
                target: {
                  name: props.name,
                  value: value
                }
              });
            };
            return /*#__PURE__*/React.createElement(Toggle, {
              disabled: props.disabled
              // id is required.
              ,
              id: inputId,
              name: inputName
              // hideLabel: use "[] sideLabel" instead of "label:" with colon on a line before
              ,
              hideLabel: true,
              labelText: this.props.label,
              onToggle: handleToggle,
              toggled: !!value
            });
          }
          var labelMarkdown = /*#__PURE__*/React.createElement(Markdown, {
            className: "checkboxLabel",
            content: this.props.label
          });
          return /*#__PURE__*/React.createElement(Checkbox, _extends({
            labelText: labelMarkdown,
            id: inputId,
            name: inputName,
            onChange: function onChange(evt, _ref2) {
              var checked = _ref2.checked,
                id = _ref2.id;
              return props.onFieldChange(evt);
            },
            checked: !!value,
            disabled: props.disabled
          }, extraCheckboxProps));
        case "dropdown":
          if (props.paramDef.readonly !== undefined && !props.paramDef.readonly) {
            var _props$wizardStep;
            var items = props.paramDef.enum && props.paramDef.enum.length ? props.paramDef.enum.map(function (i) {
              if (typeof i === "string") {
                return {
                  id: i,
                  label: i
                };
              } else {
                return {
                  id: i.value,
                  label: i.value
                };
              }
            }) : [];
            var selectedItem = items.find(function (i) {
              return i.id === props.value;
            });
            if (!selectedItem && props.value) {
              // add a new item with the given value
              selectedItem = {
                id: props.value,
                label: props.value
              };
              items.push(selectedItem);
            }
            if (undefined === selectedItem) {
              // set to null rather than undefined to avoid browser console stack trace referencing:
              // https://github.com/downshift-js/downshift#control-props
              // Warning: A component is changing an uncontrolled input of type text to be controlled.
              // Input elements should not switch from uncontrolled to controlled (or vice versa).
              // Decide between using a controlled or uncontrolled input element for the lifetime of the component.
              selectedItem = null;
            }
            // adapt data to an event
            var _handleChange = function _handleChange(data) {
              var value = typeof data === 'string' ? data : data && data.selectedItem ? data.selectedItem.id : '';
              if (value !== props.value) {
                props.onFieldChange({
                  target: {
                    name: props.name,
                    value: value
                  }
                });
              }
            };
            var _stepName = (_props$wizardStep = props.wizardStep) === null || _props$wizardStep === void 0 ? void 0 : _props$wizardStep.getName();
            return /*#__PURE__*/React.createElement("div", {
              className: "combo-container"
            }, /*#__PURE__*/React.createElement(ComboBox, {
              id: props.name + (_stepName ? "_".concat(_stepName) : toolIntegName ? "_".concat(toolIntegName) : ""),
              placeholder: placeholderText || label,
              items: items,
              className: isLoading ? 'loading' : '',
              selectedItem: selectedItem,
              invalid: isInvalid,
              invalidText: tooltipValue,
              onChange: _handleChange,
              onInputChange: _handleChange,
              shouldFilterItem: function shouldFilterItem(i) {
                return i.item !== selectedItem;
              },
              light: lightBackground,
              name: props.name,
              titleText: props.name,
              allowCustomValue: true
            }), /*#__PURE__*/React.createElement("div", {
              className: populateSpinner
            }, /*#__PURE__*/React.createElement(InlineLoading, {
              className: "spinner-icon"
            })));
          }
          var tooltipVal, propertyValue;
          var propsEnum = props.paramDef.enum;
          var disabled = false;
          if (propsEnum && propsEnum.length > 0 && props.value === "") {
            // Note above componentDidUpdate will set this.props.value to enum[0] on next update
            propertyValue = propsEnum[0];
            if (_typeof(propertyValue) === "object") {
              propertyValue = Object.keys(propertyValue)[0];
            }
          } else {
            propertyValue = props.value;
          }
          var disabled = propsEnum.length > 0 ? false : true;
          if (props.paramDef.disabled === false) {
            disabled = props.paramDef.disabled;
          }
          if (disabled) {
            propsEnum = [{
              "name": commonMsgs.get("loading"),
              "value": commonMsgs.get("loading")
            }];
          }
          if (propsEnum && propsEnum.length === 0 && props.required) {
            tooltipVal = messages.get("error.schema.required");
            maybeRequired["data-show-required-tooltip"] = true;
            maybeRequired["data-invalid"] = true;
          }
          var enumDescription;
          if (propsEnum && propsEnum.length > 0) {
            var found = propsEnum.find(function (e) {
              return propertyValue === e.value;
            });
            enumDescription = found && found.description;
          }

          // Show pattern match errors for select controls
          // Used by setup-authorization-type properties from some otc-toolint-broker tools
          var showPatternError = false;
          if (isInvalid && tooltipValue && props.paramDef.pattern) {
            maybeRequired["data-show-required-tooltip"] = true;
            maybeRequired["data-invalid"] = true;
            showPatternError = true;
          }
          return /*#__PURE__*/React.createElement("div", {
            className: "cds--select" + (lightBackground ? " cds--select--light" : "")
          }, /*#__PURE__*/React.createElement("div", _extends({
            className: "cds--select-input__wrapper"
          }, showPatternError ? maybeRequired : {}), /*#__PURE__*/React.createElement("select", _extends({
            name: props.name,
            "aria-label": label,
            value: propertyValue,
            selected: propertyValue,
            onChange: props.onFieldChange,
            className: "cds--select-input",
            disabled: props.disabled || disabled
          }, maybeRequired), propsEnum.map(function (option) {
            var name = option,
              value = option;
            if (_typeof(option) === "object") {
              name = option.name || Object.values(option)[0];
              value = option.value || Object.keys(option)[0];
            }
            return /*#__PURE__*/React.createElement("option", {
              className: "cds--select-option",
              key: value,
              value: value
            }, name);
          })), /*#__PURE__*/React.createElement("div", {
            className: populateSpinner
          }, /*#__PURE__*/React.createElement(InlineLoading, {
            className: "spinner-icon"
          })), !isLoading && /*#__PURE__*/React.createElement(ChevronDown, {
            className: "cds--select__arrow"
          })), enumDescription ? /*#__PURE__*/React.createElement(Markdown, {
            className: "info-desc",
            content: enumDescription
          }) : /*#__PURE__*/React.createElement("div", {
            className: "cds--form-requirement"
          }, propertyValue === "" || showPatternError ? tooltipVal || tooltipValue : ""));
        case "section":
          return /*#__PURE__*/React.createElement("div", null, props.paramDef.items.map(function (item, i) {
            var key = item.key || "";
            if (!_this8.props.filteredItems || _this8.props.filteredItems && key in _this8.props.filteredItems) {
              if (_this8.props.isFieldHidden && _this8.props.isFieldHidden(key)) {
                return null;
              }
              return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, props, {
                key: key ? "".concat(key, "_").concat(i) : "sectionItem_".concat(i),
                controller: props.controller,
                capability: props.capability,
                onFieldChange: props.onFieldChange,
                paramDef: item,
                name: key,
                value: parameters[key] || ""
              }));
            }
          }));
        case "group":
          return /*#__PURE__*/React.createElement("div", {
            className: "group-div"
          }, props.paramDef.items.map(function (item, i) {
            var key = item.key || "";
            if (!_this8.props.filteredItems || _this8.props.filteredItems && key in _this8.props.filteredItems) {
              if (_this8.props.isFieldHidden && _this8.props.isFieldHidden(key)) {
                return null;
              }
              return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, props, {
                key: key ? "".concat(key, "_").concat(i) : "groupItem_".concat(i),
                controller: props.controller,
                capability: props.capability,
                onFieldChange: props.onFieldChange,
                paramDef: item,
                name: key,
                value: parameters[key] || ""
              }));
            }
          }));
        case "table":
          return /*#__PURE__*/React.createElement("table", {
            role: "presentation",
            className: "table-form"
          }, /*#__PURE__*/React.createElement("tbody", null, function () {
            var rows = [];
            var colCount = props.paramDef.columnCount;
            var items = props.paramDef.items;
            var widths = props.paramDef.widths;
            var ariaLabelledbys = [];
            for (var i = 0; i < items.length; i += colCount) {
              rows.push(items.slice(i, i + colCount).map(function (item, j) {
                var key = item.key || "";
                var value = parameters[key] || "";
                var extraProps = {};
                if (i === 0) {
                  extraProps.id = item.title ? item.title.replace(/\s+/g, "") : null;
                  ariaLabelledbys.push(extraProps.id);
                } else {
                  extraProps.ariaLabelledby = ariaLabelledbys[j];
                }
                if (item.type === "label" && item.tooltip) {
                  // Render tooltip next to the label in the table
                  var tooltipText = item.tooltip;
                  var _titleText = item.title;
                  var tooltipContent = /*#__PURE__*/React.createElement("div", {
                    className: "info-div-left"
                  }, /*#__PURE__*/React.createElement(Toggletip, {
                    className: "tooltip",
                    align: "right"
                  }, /*#__PURE__*/React.createElement(ToggletipButton, null, /*#__PURE__*/React.createElement(Information, null)), /*#__PURE__*/React.createElement(ToggletipContent, null, /*#__PURE__*/React.createElement(Markdown, {
                    content: tooltipText
                  }))));
                  return /*#__PURE__*/React.createElement("div", {
                    key: "".concat(i, "_").concat(j),
                    className: "detailsFormLabelDiv"
                  }, /*#__PURE__*/React.createElement("label", {
                    className: "cds--label"
                  }, _titleText), tooltipContent);
                } else {
                  return /*#__PURE__*/React.createElement(InputElement, _extends({}, props, extraProps, {
                    key: "".concat(i, "_").concat(j),
                    capability: props.capability,
                    onFieldChange: props.onFieldChange,
                    paramDef: item,
                    name: key,
                    value: value,
                    required: item.required
                  }));
                }
              }));
            }
            return rows.map(function (rowItems, i) {
              var cells = rowItems.map(function (item, j) {
                var style = {};
                if (widths) {
                  style.width = widths[j];
                  style.verticalAlign = "middle";
                  style.overflowWrap = "break-word";
                }
                return /*#__PURE__*/React.createElement("td", {
                  key: "".concat(i, "_").concat(j),
                  style: style
                }, item);
              });
              return /*#__PURE__*/React.createElement("tr", {
                key: i
              }, cells);
            });
          }()));
        case "status":
          try {
            if (!isLoading && props.paramDef && props.paramDef.status) {
              var status = JSON.parse(props.paramDef.status);
              // Note, using otc-ui <Notification instead of carbon <InlineNotification,
              // because when the error response is translatable string: status.check.failure
              // that string contains a link, and use of InlineNotification with a link gives blank page
              // with browser console error:
              //   Error: component should have no interactive child nodes.
              //     at useNoInteractiveChildren.js:17:1
              return /*#__PURE__*/React.createElement("div", {
                className: "textInfo"
              }, /*#__PURE__*/React.createElement(Notification, {
                kind: status.status,
                lowContrast: true,
                title: status.title,
                format: "markdown",
                subtitle: status.message || ""
              }));
            } else {
              // Note, the subtitle here does not contain a link
              // so could use InlineNotification, but using <Notification for consistency.
              return /*#__PURE__*/React.createElement("div", {
                className: "textInfo"
              }, /*#__PURE__*/React.createElement(Notification, {
                kind: 'info',
                lowContrast: true,
                title: messages.get("status.check.title"),
                subtitle: messages.get("status.check.in.progress") || ""
              }));
            }
          } catch (e) {
            // Don't render anything
            // Not fully sure when this would catch error. Maybe when invalid markdown
            // due to translator mistake, or due to validator-v1 had a problem
            // so props.paramDef.status doesn't parse as json successfully.
            console.error("in param-div case status, error.");
            console.error(e);
          }
          return null;
        case "accordion":
          var titleText = props.paramDef.title;

          // Build custom accordion expando button
          var expandoButton = function expandoButton(props) {
            return /*#__PURE__*/React.createElement("button", props, /*#__PURE__*/React.createElement(ChevronRight, {
              className: "cds--accordion__arrow"
            }), /*#__PURE__*/React.createElement("div", {
              className: "cds--accordion__title"
            }, titleText));
          };
          return /*#__PURE__*/React.createElement(Accordion, null, /*#__PURE__*/React.createElement(AccordionItem, {
            key: titleText,
            title: titleText,
            open: false,
            renderToggle: expandoButton
          }, props.paramDef.items.map(function (item, i) {
            var key = item.key || "";
            if (!_this8.props.filteredItems || _this8.props.filteredItems && key in _this8.props.filteredItems) {
              if (_this8.props.isFieldHidden && _this8.props.isFieldHidden(key)) {
                return null;
              }
              return /*#__PURE__*/React.createElement(ParamDiv, _extends({}, props, {
                key: key ? "".concat(key, "_").concat(i) : "accordianItem_".concat(i),
                controller: props.controller,
                capability: props.capability,
                onFieldChange: props.onFieldChange,
                paramDef: item,
                name: key,
                value: parameters[key] || ""
              }));
            }
          })));
        case "radiogroup":
          var paramDef = props.paramDef;

          // adapt data to an event
          var handleChange = function handleChange(data) {
            if (data !== props.value) {
              props.onFieldChange({
                target: {
                  name: props.name,
                  value: data
                }
              });
            }
          };
          var orientation = paramDef.display && paramDef.display.orientation;
          return /*#__PURE__*/React.createElement(RadioButtonGroup, {
            defaultSelected: props.value,
            name: props.name,
            valueSelected: props.value,
            onChange: handleChange,
            orientation: orientation ? orientation : 'vertical'
          }, paramDef.enum.map(function (item) {
            return /*#__PURE__*/React.createElement(RadioButton, {
              labelText: item.name,
              value: item.value,
              key: item.value
            });
          }));
        case "tilegroup":
          var tilesDef = props.paramDef;

          // adapt data to an event
          var handleTileChange = function handleTileChange(data) {
            if (data !== props.value) {
              props.onFieldChange({
                target: {
                  name: props.name,
                  value: data
                }
              });
            }
          };

          // Render TileGroup wrapping RadioTile(s)
          var ariaLabel = tilesDef.title || tilesDef.description || props.name;
          var isSolo = ((_tilesDef$enum = tilesDef.enum) === null || _tilesDef$enum === void 0 ? void 0 : _tilesDef$enum.length) === 1;
          var stepName = props.wizardStep && props.wizardStep.getName();
          var tileGroupClass = ((_tilesDef$display = tilesDef.display) === null || _tilesDef$display === void 0 ? void 0 : _tilesDef$display.orientation) === "vertical" ? "tile-group tile-group-vertical" : "tile-group tile-group-horizontal";
          if (isSolo) {
            var tileData = getTileData(tilesDef.enum[0], tilesDef);
            if (!tileData) {
              return;
            }
            var name = tileData.name,
              _value = tileData.value;
            return renderTile({
              isSolo: isSolo,
              name: name,
              stepName: stepName,
              value: _value
            });
          }
          return /*#__PURE__*/React.createElement(TileGroup, {
            "aria-label": ariaLabel,
            className: tileGroupClass,
            defaultSelected: ((_tilesDef$enum2 = tilesDef.enum) === null || _tilesDef$enum2 === void 0 ? void 0 : _tilesDef$enum2.length) && tilesDef.enum[0].value,
            disabled: props.disabled,
            name: props.name,
            onChange: handleTileChange,
            valueSelected: props.value,
            legend: ariaLabel
          }, ((_tilesDef$enum3 = tilesDef.enum) === null || _tilesDef$enum3 === void 0 ? void 0 : _tilesDef$enum3.length) && tilesDef.enum.map(function (option) {
            var tileData = getTileData(option, tilesDef);
            if (!tileData) {
              // Title does not exist for entry. Do not create a select option.
              return;
            }
            var name = tileData.name,
              value = tileData.value;
            return renderTile({
              isSolo: isSolo,
              name: name,
              stepName: stepName,
              value: value
            });
          }));
        case "radiocards":
          {
            var radioCardIconMap = {
              github: /*#__PURE__*/React.createElement(LogoGithub, {
                size: 24
              }),
              user: /*#__PURE__*/React.createElement(User, {
                size: 24
              })
            };
            var radioCardsDef = props.paramDef;
            var radioCardsName = props.name;
            var radioCardsDomName = toolIntegName ? "".concat(toolIntegName, "-").concat(radioCardsName) : radioCardsName;
            var radioCardsValue = props.value;
            var handleRadioCardChange = function handleRadioCardChange(selectedValue) {
              if (selectedValue !== radioCardsValue) {
                props.onFieldChange({
                  target: {
                    name: radioCardsName,
                    value: selectedValue
                  }
                });
              }
            };
            var selectedOption = radioCardsDef.enum && radioCardsDef.enum.find(function (opt) {
              var val = _typeof(opt) === 'object' ? opt.value : opt;
              return val === radioCardsValue;
            });
            var selectedDetail = selectedOption && selectedOption.detail;
            return /*#__PURE__*/React.createElement("div", {
              className: "radio-cards"
            }, /*#__PURE__*/React.createElement("div", {
              className: "radio-cards__grid"
            }, radioCardsDef.enum && radioCardsDef.enum.map(function (option) {
              var optValue = _typeof(option) === 'object' ? option.value : option;
              var optName = _typeof(option) === 'object' ? option.name : option;
              var optDesc = _typeof(option) === 'object' ? option.description : '';
              var optIcon = _typeof(option) === 'object' ? option.icon : null;
              var isChecked = optValue === radioCardsValue;
              var cardId = "".concat(radioCardsDomName, "-").concat(optValue);
              return /*#__PURE__*/React.createElement("label", {
                key: optValue,
                htmlFor: cardId,
                className: "radio-cards__card".concat(isChecked ? ' radio-cards__card--selected' : '')
              }, /*#__PURE__*/React.createElement("input", {
                type: "radio",
                id: cardId,
                name: radioCardsDomName,
                value: optValue,
                checked: isChecked,
                onChange: function onChange() {
                  return handleRadioCardChange(optValue);
                },
                className: "radio-cards__input",
                disabled: props.disabled
              }), /*#__PURE__*/React.createElement("span", {
                className: "radio-cards__radio-indicator"
              }), /*#__PURE__*/React.createElement("span", {
                className: "radio-cards__icon".concat(optIcon ? " radio-cards__icon--".concat(optIcon) : ''),
                "aria-hidden": "true"
              }, radioCardIconMap[optIcon] || /*#__PURE__*/React.createElement(Application, {
                size: 24
              })), /*#__PURE__*/React.createElement("span", {
                className: "radio-cards__content"
              }, /*#__PURE__*/React.createElement("span", {
                className: "radio-cards__title"
              }, optName), optDesc && /*#__PURE__*/React.createElement("span", {
                className: "radio-cards__description"
              }, optDesc)));
            })), selectedDetail && /*#__PURE__*/React.createElement("div", {
              className: "radio-cards__detail-panel"
            }, /*#__PURE__*/React.createElement("span", {
              className: "radio-cards__detail-title"
            }, selectedDetail.title), selectedDetail.tag && /*#__PURE__*/React.createElement(Tag, {
              type: "green",
              size: "sm",
              className: "radio-cards__detail-tag"
            }, selectedDetail.tag), selectedDetail.description && /*#__PURE__*/React.createElement("p", {
              className: "radio-cards__detail-description"
            }, selectedDetail.description)));
          }
        case "propertylist":
          return /*#__PURE__*/React.createElement(PropertyTable, {
            bssAccount: this.props.userInfo && this.props.userInfo.bss_account,
            envId: this.props.envId,
            handleChange: function handleChange(newProperties) {
              props.onFieldChange({
                target: {
                  name: props.name,
                  value: newProperties
                }
              });
            },
            id: "property-list",
            lang: this.props.locale,
            persistentSearch: true,
            properties: value || [],
            toolchainId: toolchainId,
            toolchainServices: this.props.toolchainServices || []
          });
        case "authorizationbtn":
          var disableButton = false;
          if (this.props.validatorRunning) {
            disableButton = true;
          } else {
            if (this.props.invalidProps) {
              disableButton = !!Object.keys(this.props.invalidProps).find(function (key) {
                return _this8.props.invalidProps[key] === true;
              });
            }
          }
          return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("button", {
            disabled: disableButton,
            className: "cds--btn cds--btn--primary cds--btn--field",
            onClick: this.handleCreateAuthorizationClick
          }, messages.get("button.createAuthorization")), /*#__PURE__*/React.createElement(Modal, {
            open: this.state.notifyDialog.open,
            modalHeading: this.state.notifyDialog.heading,
            primaryButtonText: messages.get("modal.close"),
            onRequestClose: function onRequestClose() {
              return _this8.setState({
                notifyDialog: {
                  open: false
                }
              });
            },
            onRequestSubmit: function onRequestSubmit() {
              return _this8.setState({
                notifyDialog: {
                  open: false
                }
              });
            }
          }, this.state.notifyDialog.dangerousHtmlDescription ? /*#__PURE__*/React.createElement("div", {
            dangerouslySetInnerHTML: {
              __html: this.state.notifyDialog.dangerousHtmlDescription
            }
          }) : /*#__PURE__*/React.createElement("div", null, this.state.notifyDialog.description)));
      }
      return element;
    }
  }]);
}(React.Component);
InputElement.propTypes = _objectSpread(_objectSpread({}, InputElement.propTypes), {}, {
  enableSecretSmProvider: PropTypes.bool.isRequired,
  wizardMode: PropTypes.bool.isRequired
});